import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyFormatter' })
export class CurrencyFormatterPipe implements PipeTransform {
  constructor() {}

  transform(
    value: number | string,
    currencySymbol: string,
    isCurrencySymbolBefore: boolean = true
  ): string {
    return isCurrencySymbolBefore
      ? currencySymbol + ' ' + value
      : value + ' ' + currencySymbol;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/pipe/currency-formatter.pipe.ts